/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';
import logo from '../../images/Norhli_Logo_White.svg';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger;

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');

        //Init mmenu
        const menu = new Mmenu(mobileMenuSelector, {
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        `<a href='/'><img src='${logo}' /></a>`,
                        `<button type="button" class="menu-nav-mobile__btn" aria-label="Close menu"><span class="menu-nav-mobile__burger close"></span></button>`
                    ]
                }
            ],
            navbar: false,
            slidingSubmenus: true,
            offCanvas: {
                use: true,
                position: "right"
            },
        }, {
            offCanvas: {
                page: {
                    nodeType: "main",
                    selector: mainContentSelector
                }
            }
        });
        const mmenuApi = menu.API;

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                mmenuApi.open();
            }
        });

        document.addEventListener("click", (e) => {
            if (e.target.closest(".menu-nav-mobile__burger.close")) {
                mmenuApi.close();
            }
        });

        // Close mmenu if screen width gets over breakpoint
        var mediaQuery = window.matchMedia("(min-width: 768px)");
        mediaQuery.addEventListener("change", function () {
            if (mmenuApi) {
                mmenuApi.close();
            }
        });
    };

    init();
}
